/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

import './styles.scss';
import TitlePages from 'components/_base/TitlePages';
import SubHeader from 'components/SubHeader';
import { Modal } from 'react-bootstrap';
import { tabs, passos } from '../../_constants';

import TipoMaterialLista from './TipoMaterialLista';

const Materiais = (props) => {
  let updateRascunho = props.updateRascunho;
  let model = props.model;
  let entities = props.entities;
  // let setModel = props.setModel;
  let renderErrors = props.renderErrors;
  let setActiveTab = props.setActiveTab;

  let errors = (model.errors || []).filter((error) => error.passo === passos.passoMateriais.nro);
  model.solicitacoes = model.solicitacoes || [];

  // const materiais = []
  //   .concat(
  //     ...(entities.tipoMateriais || []).map(
  //       (tipoMaterial) => tipoMaterial.materiaisComunicacao
  //     )
  //   )

  const tipoMateriais =
    (entities.tipoMateriais || []).filter(
      (tipoMaterial) =>
        !model.materialTipoSigla?.length ||
        model.materialTipoSigla.length === 0 ||
        tipoMaterial?.sigla === model.materialTipoSigla
    ) || [];

  let materiais = [];
  tipoMateriais?.forEach((element) => {
    materiais = materiais.concat(element.materiaisComunicacao || []);
  });

  // verificar se materiais tem mais de 1 canal
  // const temMaisDeUmCanal = materiais.some(
  //   (material) => material.materialComunicacaoCanais.length > 1
  // );

  // console.log('temMaisDeUmCanal', temMaisDeUmCanal);
  // if (!temMaisDeUmCanal) {
  const canalId = model.loja?.canalId || 0;

  /** identificar ordem dos materiais de acordo com o materialComunicacaoCanais */
  let listaOrdem = materiais.map((material) => ({
    materialComunicacaoId: material.materialComunicacaoId,
    ordem:
      material.materialComunicacaoCanais.find(
        (x) => x.canalId === canalId && x.materialComunicacaoId === material.materialComunicacaoId
      )?.ordem ?? 999999,
  }));

  listaOrdem = listaOrdem.sort((a, b) => a.ordem - b.ordem);

  /** sequência dos materiais conforme a ordem definida em listaOrdem */
  materiais = listaOrdem.map((it) =>
    materiais.find((material) => material.materialComunicacaoId === it.materialComunicacaoId)
  );
  // } else {
  //   materiais = materiais.sort((a, b) => a.ordem - b.ordem);
  // }

  const removeSolicitacaoMaterialInvalido = (solicitacoes, materiais) => {
    let materialIds = materiais.map((m) => m.materialComunicacaoId);
    let validos = solicitacoes.filter((item) =>
      materialIds.includes(item.materialComunicacaoId));

    return validos;
  };

  model.solicitacoes = removeSolicitacaoMaterialInvalido(model.solicitacoes, materiais);

  // const showModal = () => {
  //   return model.solicitacoes?.length > 0;
  // };

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {

  }, [showModal]);

  return (
    <div className="wrapper-content-pedido-materiais">
      <SubHeader title={model.loja?.razaoSocial} />

      <TitlePages title="Selecione os Materiais" />

      <hr />

      <div className="content-pedido-materiais">
        {renderErrors(errors)}

        <TipoMaterialLista materiais={materiais} model={model} entities={entities} />

        <div className="row buttons">
          <div className="col">
            <button
              className="btn btn-primary btn-navigation"
              onClick={() => {
                updateRascunho();
                setActiveTab(tabs.tabCliente);
              }}
            >
              <span>
                <FaAngleLeft size={26} />
              </span>
              <span>VOLTAR</span>
            </button>
          </div>

          <div className="col flex-row-reverse">
            <button
              className="btn btn-primary btn-navigation btn-navigation-right"
              onClick={() => {
                if (model.solicitacoes?.length <= 0) {
                  setShowModal(true);
                }
                else {
                  setShowModal(false);
                  updateRascunho();
                  setActiveTab(tabs.tabEntrega);
                }
              }}
            >
              <span>AVANÇAR</span>
              <span>
                <FaAngleRight size={26} />
              </span>
            </button>
          </div>
        </div>
      </div>

      <Modal className="modal-sem-material" show={showModal} onHide={() => { setShowModal(false) }}>
        <Modal.Body className="text-center">
          <h4 className="m-3">Seleção de Materiais</h4>

          <p className="m-3">
            Por favor, selecione pelo menos um material de comunicação.
          </p>

        </Modal.Body>
      </Modal>

    </div>
  );
};

export default Materiais;
